import * as Sentry from '@sentry/react';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;

let initialized = false;

function hasWebSentry() {
  return Boolean(SENTRY_DSN);
}

export function initWebSentry() {
  if (initialized || !hasWebSentry()) {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    enabled: true,
    environment: import.meta.env.PROD ? 'production' : 'development',
    attachStacktrace: true,
    sendDefaultPii: false,
  });

  Sentry.setTag('surface', 'web');
  Sentry.setTag('app-name', 'kindred');
  initialized = true;
}

export function syncWebSentryUser(input: { id: string; email?: string | null } | null) {
  if (!hasWebSentry()) {
    return;
  }

  if (!input) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({
    id: input.id,
    email: input.email || undefined,
  });
}
